<template>
    <div class="content">
        <div class="referral-nav">
            <h2>Referrals</h2>
            
        </div>
        <div class="referral-card">
            <div class="text-center referral-notice">
                <img class="parcel" src="./../../../assets/style/images/parcel.svg" alt="reward">
                <p>Tell business owners about hrdesk, you both get 5% discount on Service Charges</p>
            </div>
            <div class=" text-center steps">
                <span>1</span><hr><span>2</span><hr><span>3</span>
            </div>
            <div class="step-info" >
                <span class="col-md-1">Invite your friends</span>
                <span class="col-md-8">They run payroll</span>
                <span class="col-md-3">You earn money!</span>
            </div>
            <div class="row justify-content-center">
            <div class=" text-center" id="start">
                <div>Not sure who to invite? We'll make smart suggestions.</div>
                <button class="btn btn-primary mail"><img class="gmail" src="./../../../assets/style/images/gmail.svg" alt="gmail">Sync Google Contacts</button>
            </div>
            </div>
            <div class="form-group text-center send-mail">
                <input type="email" name="" id="enter-email" class="form-control" placeholder="Enter email addresses" aria-describedby="helpId">
                <button type="button" class="btn btn-secondary btn-sm invite">Send Invites</button>
            </div>
            <div class="text-center link">
                <p>or just copy and share this link</p>
                <div class=" mb-3 share-link">
                    <input type="email" class="form-control input" placeholder="" aria-label="Recipient's username" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                        <span class="input-group-text btn btn-primary" id="basic-addon2">Copy Link</span>
                    </div>
                </div>
               
                <div class="social-media-icons text-center">
                    Share this on:
                    <a href="#"><i class="fa fa-facebook fa-sm"></i></a>
                    <a href="#"><i class="fa fa-twitter fa-sm"></i></a>
                    <a href="#"><i class="fa fa-instagram fa-sm"></i></a>
                </div>
        
            </div>
            <div class="text-center foot-note">
                To qualify, your friend must sign up and run payroll. You will both receive a ₦1000  gift card within 30 days after their free trial period has expired and they have paid for the payroll service. 
            </div> 
        </div>
    </div>   
</template>
<script>
export default {
    name: "Referralpage",
};
</script>

<style lang="scss" scoped>
    @import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css);
  
    div.content {
    padding-bottom: 31.5px;
    padding-top: 35px;
    padding-left: 60px;
    padding-right: 60px;
    .referral-nav {
    width: 980px;
    height: 35px;
    color: #302f2f;
    display: flex;
    border-bottom: 1px solid #ebe4e4;
    margin-top: 25px;
        h2{
        font-family: Nunito;
        font-size: 1.908vw;
        font-weight:900;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: left;
        }
    }
    .referral-card {
    width: 950px;
    margin-left: 15px;
    margin-top: 2em;
    border-radius: 2px;
    align-content: center;
    justify-content: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;

        .referral-notice {
            font-family: Nunito;
            font-size: 1.200vw;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.07;
            letter-spacing: normal;
            color: #000;
            padding-top: 43px;
            .parcel{
                width: 50px;
                height: 45px;
                margin-bottom: 30px;
            }
        }
        .steps {
            display: inline-flex;
            justify-content: center;
            font-size: 1.280vw;
            font-weight: 600px;
            margin-top: 30px;
            span{
                width: 40px;
                border-radius:100%;
                background-color: #5099de;
                padding: 8px;
                color:#fff;
            }
            hr{
                color: #5099de;
                border: 1px solid #5099de;
                width:10em;
                margin-left: 0px;
                margin-right: 0px;
                margin-top: 20px;
            }
        }  
        .step-info{
            width:700px;
            margin-top:20px;
            text-align: center;
            font-size: 0.800vw;
            margin-left:11.5em;
            span:nth-child(3){
                margin-left:1em;
            }
            span{
                padding: 0em 6em;
            }
        }  
        #start {
            width: 43%;
            height: 150px;
            border-radius: 5px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
            border: solid 2px #5099de;
            background-color: #edf9f7;
            padding: 3em 1em;
            margin-top: 5em;
            margin-left: 25px;
            font-size: 0.906vw;
            .mail {
                width: 145px;
                padding:10px;
                margin-top: 2em;
                background-color: #5099de;
                font-family: Nunito;
                font-size: 0.800vw;
                line-height: 12px;
                .gmail{
                    width:15px;
                    padding-right:4px;
                }
            }
        }
        .send-mail{
            margin-top: 1em;
            display: inline-flex;
            font-size: 0.500vw;
            padding: 10em 20em;
            #enter-email{
            margin-right: 35px;
            border-radius: 5px;
            border: solid 1px rgba(199, 199, 199, 0.98);
            background-color: #ffffff;
            font-size: 1.000vw;
            }
            .invite{
                font-size: 1.000vw;
                width: 232.9px;
                color: #000;
                border-radius: 5px;
                border: solid 1px rgba(217, 217, 217, 0.98);
                background-color: rgba(217, 217, 217, 0.98);
            }
        }
        .link{
             margin-top: 1em;
                p{
                 font-weight: 600;
                 line-height: 20px;
                 font-stretch: normal;
                 letter-spacing: 1.5px;
                }
        
            .share-link{
                margin-top: 1em;
                margin-left: 9em;
                padding-right: 12px;
                display: inline-flex;
                .input{
                    width: 1100px;
                    padding: 10px;
                    display:inline-flex;
                    border: solid 1px #c7c7c7;
                    background-color: #ffffff;
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                }
                span{
                    width:150px;
                    height:39px;
                    padding: 8.5px 45px;
                    font-size: 1.000vw;
                    background-color: #5099de;
                    color: #ffffff;
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                    margin-right: 2px;
                }
            }
        }
        .social-media-icons {
            font-size: 0.980vw;
            margin: 30px 0px;
            a {	
            text-decoration: none;
            padding: 14px;
            &:first-child{
                padding-left: 25px;
            }
            }
        }

        .social-media-icons a:nth-child(1) i {
            color: #fff;
            border-radius: 50%;
            background-color: #002665;
            padding: 5px;
            width: 25px;
        }

        .social-media-icons a:nth-child(2) i {
            color: #FFF;
            border-radius: 50%;
            background-color: #63c9ef;
            padding: 5px;
            width: 25px;
        }

        .social-media-icons a:nth-child(3) i {
            color: #FFF;
            border-radius: 50%;
            background-color: #f17d6b;
            padding: 5px;
            width: 25px;
        }

        .social-media-icons a:nth-child(4) i {
            color: #FF6600;
        }

        .social-media-icons a i:hover{
            color: #a5c8fc;
        }
                       
        .foot-note {
            width: 700px;
            opacity: 0.3;
            font-family: Nunito;
            font-size: 1.100vw;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.30;
            letter-spacing: normal;
            text-align: center;
            color: #777777;
            padding: 1.5em 3em;
            margin-left: 8em;
            padding-bottom: 4em;
        }
    }  
}
</style>



